import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity5 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_5;
}

export default DirtRoadTileEntity5;
